import  { useState } from 'react';
import WithdrawModal from '../../modals/withdraw';
import { Footer } from '../../../components/footer';
import { useProfileDetails, useUserTotalWithdraw } from '../../profile-details/api/profileapi';
import Loader from '../../Loader/buttonLoad';
import { Link, useNavigate } from 'react-router-dom';

const MasterWallet = () => {
    const [withdrawModal, setWithdrawModal] = useState(false);
    const { data: profileData, isLoading: profileLoading } = useProfileDetails()
    const {data:totalBalance}=useUserTotalWithdraw()
   

    const navigate = useNavigate()
    let overAllBalance = profileData?.masterWallet + totalBalance

    const redeemWalletTabs = [
        { tabName: 'Withdraw History', navigationto: '/withdraw-history' },
        { tabName: 'Referral Income', navigationto: '/master-referral-income' },
        { tabName: 'Top-Up Income', navigationto: '/master-top-up-income' },
        { tabName: 'Swap Income', navigationto: '/swap-history' },
        { tabName: 'Top-Up Completion', navigationto: '/top-up-completion-history' },
        { tabName: 'ICO Referral Income', navigationto: '/master-ico-referral-income' },
    ]

    return (


        <div>
            {(profileLoading) && <Loader />}

            <div className="mainContent">
                <div className="pageContent def-py-30">
                    <div className='container'>
                        
                        <div className="appPagetitle">
                        <button className='btn btnBack' onClick={() => navigate('/dashboard')}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button> Master Wallet</div>
                        <div className='row'>
                            <div className="col-lg-12">
                                <div className="appcard mb-4 p-4">
                                    <div className="row align-items-center">
                                        <div className="col-lg-4 mb-3 mb-lg-0">
                                            <div className='d-flex g-15 align-items-center'>
                                                <div className='masterWalletIcon animate__animated animate__pulse animate__infinite'>
                                                    <img src={require('../../../assets/images/master-wallet/masterwalletImg.svg').default} alt='masterwalletImg' className='img-fluid animate__animated animate__pulse animate__infinite' />
                                                </div>
                                                <div className='rightLevelcnt'>
                                                    <div className='labelTxt'>Wallet Balance</div>
                                                    <div className='labelVal'>{profileData?.masterWallet ? parseFloat(profileData?.masterWallet).toFixed(4) : 0} <span className='fs-14 fw-400 text-white-60'>USDT</span></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-8">
                                            <div className="row rightLevelcnt">
                                                <div className="col-md col-sm-6 mb-3 mb-md-0">
                                                    <div>
                                                        <div className='labelTxt'>Over All Balance</div>
                                                        <div className='labelVal'>{totalBalance === 0 ? parseFloat(profileData?.masterWallet).toFixed(4) : parseFloat(overAllBalance).toFixed(4)} <span className='fs-14 fw-400 text-white-60'>USDT</span></div>
                                                    </div>
                                                </div>
                                                <div className="col-md col-sm-6 mb-3 mb-md-0">
                                                    <div>
                                                        <div className='labelTxt'>Withdraw Amount</div>
                                                        <div className='labelVal'>{totalBalance ? parseFloat(totalBalance).toFixed(4) : 0} <span className='fs-14 fw-400 text-white-60'>USDT</span></div>
                                                    </div>
                                                </div>
                                                <div className="col-md-auto">
                                                    <button className='btn btn-primary px-4' disabled
                                                    ={sessionStorage.getItem('role') === 'adminView'} 
                                                    onClick={() => setWithdrawModal(!withdrawModal)}>Withdraw</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='card2Head'>History</div>
                                <div className="appcard mb-4 px-3 pb-2 cardbg">

                                    <div className='row justify-content-center'>
                                        <div className='col-lg-9'>
                                            <div className='row'>
                                                {redeemWalletTabs.map((item, index) =>
                                                    <div className="col-lg-4 col-md-6" key={item}>
                                                        <Link className='appDarkCard walletCard tabLinkBx mb-3' to={item.navigationto} key={'tab' + index}>
                                                            <button className='btn btnArrowcard' >
                                                                <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M8.58881 3.53662L1.28975 9.35339" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                                    <path d="M7.95354 9.15769L8.58881 3.53662" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                                    <path d="M2.96778 2.90159L8.58885 3.53686" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>
                                                            </button>
                                                            <div className='wc-name'>{item.tabName}</div>
                                                        </Link>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>




                              
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <WithdrawModal modalOpen={withdrawModal} balance={profileData?.masterWallet} modalClose={() => setWithdrawModal(!withdrawModal)} />
        </div>
    )
}

export default MasterWallet